import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UserAvatar from "../components/UserAvatar";
import { flagUrl, teacherPath } from "../services/Helper";

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');

export default function TeacherProps({ data, active, onHover }) {
  const { t } = useTranslation();
  const location = useLocation();
  const prefix = location.pathname.startsWith("/app") ? "/app" : "";
  const profileUrl = teacherPath(data, prefix);
  const bookUrl = data?.featured_course?.slug ? `${prefix}/course/${data.featured_course.slug}` : profileUrl;
  const rating = Number(data?.ratings_avg_rating || 0);
  const speaks = (data?.languages || [])
    .filter((lang) => lang?.name)
    .map((lang) => lang.type ? `${lang.name} (${capitalize(lang.type)})` : lang.name)
    .join(', ');
  const about = data?.teacher_info?.about;
  const education = [data?.teacher_info?.education_title, data?.teacher_info?.education_institue].filter(Boolean).join(' · ');

  return (
    <article
      className={`tutor-card ${active ? 'is-active' : ''}`}
      onMouseEnter={(e) => onHover?.(data, e.currentTarget)}
      onFocus={(e) => onHover?.(data, e.currentTarget)}
    >
      <Link to={profileUrl} className="tutor-card-avatar">
        <UserAvatar src={data?.avatar} name={data?.name} size={160} />
      </Link>

      <div className="tutor-card-main">
        <h3 className="tutor-card-name">
          <Link to={profileUrl}>{data?.name}</Link>
          {Number(data?.approved) === 1 &&
            <i className="fa-solid fa-shield-check tutor-card-verified" title={t("teacherProps.verified")} />
          }
          {data?.country_code &&
            <img
              className="tutor-card-flag"
              src={flagUrl(data.country_code)}
              alt={data?.country_name || data.country_code}
              title={data?.country_name || data.country_code}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          }
        </h3>

        <div className="tutor-card-tags">
          <span><i className="fa-light fa-badge-check" />{t("teacherProps.professional")}</span>
        </div>

        {data?.teaches?.length > 0 &&
          <p className="tutor-card-row">
            <i className="fa-light fa-graduation-cap" />{data.teaches.join(', ')}
          </p>
        }
        {speaks &&
          <p className="tutor-card-row">
            <i className="fa-light fa-language" />{t("teacherProps.speaks", { languages: speaks })}
          </p>
        }

        {data?.teacher_info?.bio &&
          <p className="tutor-card-headline">{data.teacher_info.bio}</p>
        }
        {about &&
          <p className="tutor-card-about">{about}</p>
        }
        <Link to={profileUrl} className="tutor-card-more">{t("teacherProps.learn_more")}</Link>

        {education &&
          <p className="tutor-card-row tutor-card-education">
            <i className="fa-light fa-award" />{education}
          </p>
        }
      </div>

      <div className="tutor-card-side">
        <div className="tutor-card-price">
          <strong>USD {data?.lesson_price}</strong>
          <span>{t("teacherProps.trial_lesson")}</span>
        </div>

        <div className="tutor-card-stats">
          <div>
            <strong>{rating > 0 ? rating.toFixed(1) : t("teacherProps.new")} {rating > 0 && <i className="fa-solid fa-star" />}</strong>
            <span>{t("teacherProps.reviews_count", { count: data?.ratings_count || 0 })}</span>
          </div>
          <div>
            <strong>{data?.students_count || 0}</strong>
            <span>{t("teacherProps.students_count", { count: data?.students_count || 0 })}</span>
          </div>
          <div>
            <strong>{data?.lessons_count || 0}</strong>
            <span>{t("teacherProps.lessons_label", { count: data?.lessons_count || 0 })}</span>
          </div>
        </div>

        <div className="tutor-card-actions">
          <Link to={bookUrl} className="btn tutor-btn-primary">{t("teacherProps.book_trial")}</Link>
          <Link to={`${prefix}/home/chat/conversation/${data?.id}`} className="btn tutor-btn-outline">{t("teacherProps.send_message")}</Link>
        </div>
      </div>

      <button type="button" className="tutor-card-fav" aria-label={t("teacherProps.save")}>
        <i className="fa-light fa-heart" />
      </button>
    </article>
  )
}
